module.exports = __webpack_public_path__ + "img/8.8a390cba.jpg";